import React from "react";
import "./subjectchart.scss";

const Subjectchart = ({ topic }) => {
  if (!topic) return null;

  return (
    <div className="subjectwise-metrics-card">
      <div className="metrics-header">
        <div className="metrics-title">Performance Metrics</div>
        <div className="metrics-score">
          <div className="metrics-marks">{topic.score_out_of}</div>
          <div className="metrics-percent">
            {topic.percentile ? `${topic.percentile}%` : "-"}
          </div>
        </div>
      </div>

      <div className="metrics-grid">
        <div className="metric-item accuracy">
          <div className="metric-value">{topic.accuracy}%</div>
          <div className="metric-label">Accuracy</div>
        </div>
        <div className="metric-item percentile">
          <div className="metric-value">{topic.percentile}%</div>
          <div className="metric-label">Percentile</div>
        </div>
        <div className="metric-item duration">
          <div className="metric-value">{topic.duration}</div>
          <div className="metric-label">Duration</div>
        </div>
        <div className="metric-item tpq">
          <div className="metric-value">{topic.avg_time_per_qn}</div>
          <div className="metric-label">TPQ (Avg)</div>
        </div>
      </div>
    </div>
  );
};

export default Subjectchart;
